import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import * as _ from 'lodash';
import 'rxjs/add/operator/map';

@Injectable()
export class ArchivoService extends TokenCommonService {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/archivo/archivo.service.ts